export const SigninTypes = {
  LOG_OUT: 'LOG_OUT',
  SET_ACCEPTED_TERMS: 'SET_ACCEPTED_TERMS',
  SET_EXTRA_DATA: 'SET_EXTRA_DATA',
  SET_REGISTER_FORM: 'SET_REGISTER_FORM',
}
